import m from 'mithril'

export default m.trust(`
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" fill="none" style="width: var(--icon-width, 12px); height: var(--icon-height, 12px);">
		<circle cx="6" cy="6" r="5.5" stroke="var(--icon-color, currentColor)"/>
		<path d="M8 6.5H4V5.5H8V6.5Z" fill="var(--icon-color, currentColor)"/>
	</svg>
`)
